<div class="table-container">
  <table class="rounded-table align-middle text-center fixed-table">
    <thead class="table-light">
      <tr>
        <th scope="col"></th>
        <th scope="col">Donor</th>
        <th scope="col" class="position-relative text-center">
          Recipient
          @if (showEditButton && isEditingRecipient) {
            <div
              class="position-absolute end-0 top-50 translate-middle-y me-2 d-flex gap-2"
            >
              <button
                *ngIf="!isSavingRecipient"
                class="btn btn-sm btn-secondary"
                (click)="onCancelRecipientEdit()"
                title="Cancel Edit"
              >
                Cancel
              </button>
              <button
                class="btn btn-sm btn-success"
                (click)="onSaveRecipient()"
                title="Save Recipient Info"
                [disabled]="isSavingRecipient || isRecipientDobInvalid"
              >
                <span
                  *ngIf="isSavingRecipient"
                  class="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                {{ isSavingRecipient ? "Saving..." : "Save" }}
              </button>
            </div>
          } @else if (showEditButton) {
            <button
              class="btn btn-sm btn-outline-primary position-absolute end-0 top-50 translate-middle-y me-2"
              (click)="onEditRecipient()"
              title="Edit Recipient Info"
            >
              <i class="bi bi-pencil-fill me-1"></i>
              <span class="d-none d-lg-inline ms-1">Edit</span>
            </button>
          }
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="text-start ps-4 width-20pt">MRN</td>
        <td>
          @if (profileInfo?.data?.donor?.epicPatientId) {
            {{ profileInfo?.data?.donor?.mrn }}
            @if (!isMrbView) {
              <i class="bi bi-pencil-fill ms-1"></i>
              <span class="hover-container">
                <span
                  class="small-link change-donor-link"
                  (click)="openEpicLookupModal('Donor')"
                >
                  Change Donor Record
                </span>
              </span>
            }
          } @else {
            <span class="subtle-text"
              >Donor patient record not linked to EPIC.</span
            >
            @if (!isMrbView) {
              <span class="small-link" (click)="openEpicLookupModal('Donor')"
                >Lookup?</span
              >
            }
          }
        </td>
        <td>
          @if (profileInfo?.data?.recipient?.epicPatientId) {
            {{ profileInfo?.data?.recipient?.mrn }}
            @if (!isMrbView) {
              <i class="bi bi-pencil-fill ms-1"></i>
              <span class="hover-container">
                <span
                  class="small-link change-donor-link"
                  (click)="openEpicLookupModal('Recipient')"
                >
                  Change Recipient Record
                </span>
              </span>
            }
          } @else {
            <span class="subtle-text"
              >Recipient patient record not linked to EPIC.</span
            >
            @if (!isMrbView) {
              <span
                class="small-link"
                (click)="openEpicLookupModal('Recipient')"
                >Lookup?</span
              >
            }
          }
        </td>
      </tr>
      <tr>
        <td class="text-start ps-4 width-20pt">Name</td>
        <td>
          {{ profileInfo?.data?.donor?.firstName }}
          {{ profileInfo?.data?.donor?.lastName }}
        </td>
        <td>
          @if (
            isEditingRecipient && !profileInfo?.data?.recipient?.epicPatientId
          ) {
            <div class="d-flex gap-2">
              <div class="d-flex flex-column w-50">
                <small class="text-muted text-start mt-1">First Name</small>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="First Name"
                  [(ngModel)]="editableRecipient.firstName"
                />
              </div>
              <div class="d-flex flex-column w-50">
                <small class="text-muted text-start mt-1">Last Name</small>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Last Name"
                  [(ngModel)]="editableRecipient.lastName"
                />
              </div>
            </div>
          } @else {
            {{ profileInfo?.data?.recipient?.firstName }}
            {{ profileInfo?.data?.recipient?.lastName }}
          }
        </td>
      </tr>
      <tr>
        <td class="text-start ps-4 width-20pt">Age</td>
        <td
          [ngClass]="{
            'status-declined': redBasicInfo.includes('age'),
            'background-light-yellow': yellowBasicInfo.includes('age'),
          }"
        >
          {{ this.calculateAge(profileInfo?.data?.donor?.dateOfBirth) }}
          @if (profileInfo?.data?.donor?.dateOfBirth) {
            <span class="subtle-text"
              >({{
                this.formatDateToMMDDYYYY(
                  profileInfo?.data?.donor?.dateOfBirth
                )
              }})</span
            >
          }
        </td>
        <td>
          @if (
            isEditingRecipient && !profileInfo?.data?.recipient?.epicPatientId
          ) {
            <div class="d-flex flex-column">
              <small class="text-muted text-start mt-1"
                >Input Recipient's Date of Birth</small
              >
              <div class="input-group input-group-sm">
                <input
                  id="recipientDob"
                  name="recipientDob"
                  class="form-control"
                  placeholder="mm/dd/yyyy"
                  [minDate]="minDob"
                  [maxDate]="maxDob"
                  ngbDatepicker
                  #datePicker="ngbDatepicker"
                  #dobCtrl="ngModel"
                  [(ngModel)]="editableRecipient.dateOfBirth"
                  (ngModelChange)="onRecipientDobChange($event, dobCtrl)"
                />
                <button
                  class="btn btn-outline-secondary"
                  (click)="datePicker.toggle()"
                  type="button"
                >
                  <i class="bi bi-calendar"></i>
                </button>
              </div>
            </div>
            <div
              *ngIf="dobCtrl.invalid && dobCtrl.touched"
              class="text-danger mt-1"
            >
              <div
                class="errorMessage"
                *ngIf="dobCtrl.errors?.['ngbDate']?.invalid"
              >
                Enter a valid date (mm/dd/yyyy).
              </div>
              <div
                class="errorMessage"
                *ngIf="dobCtrl.value && isBeforeMinDate(dobCtrl.value)"
              >
                Date must be after {{ minDob.month }}/{{ minDob.day }}/{{
                  minDob.year
                }}.
              </div>
              <div
                class="errorMessage"
                *ngIf="dobCtrl.value && isAfterMaxDate(dobCtrl.value)"
              >
                Date must be before {{ maxDob.month }}/{{ maxDob.day }}/{{
                  maxDob.year
                }}.
              </div>
            </div>
          } @else {
            {{ this.calculateAge(profileInfo?.data?.recipient?.dateOfBirth) }}
            @if (profileInfo?.data?.recipient?.dateOfBirth) {
              <span class="subtle-text"
                >({{
                  this.formatDateToMMDDYYYY(
                    profileInfo?.data?.recipient?.dateOfBirth
                  )
                }})</span
              >
            }
          }
        </td>
      </tr>
      <tr>
        <td class="text-start ps-4 width-20pt">Blood Type</td>
        <td>{{ profileInfo?.data?.donor?.bloodGroup }}</td>
        <td>
          @if (isEditingRecipient) {
            <div class="d-flex flex-column">
              <small class="text-muted text-start mt-1"
                >Select Recipient's Blood Type</small
              >
              <div ngbDropdown class="btn-group">
                <button
                  class="btn btn-sm dropdown-toggle"
                  style="border: 1px solid #dee2e6"
                  id="dropdownBloodGroup"
                  ngbDropdownToggle
                >
                  {{ editableRecipient.bloodGroup || "Blood Type" }}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBloodGroup">
                  <button
                    ngbDropdownItem
                    *ngFor="let option of bloodGroupOptions"
                    (click)="editableRecipient.bloodGroup = option"
                  >
                    {{ option }}
                  </button>
                </div>
              </div>
            </div>
          } @else {
            {{ profileInfo?.data?.recipient?.bloodGroup }}
          }
        </td>
      </tr>
      <tr>
        <td class="text-start ps-4 width-20pt">BMI</td>
        <td
          [ngClass]="{
            'status-declined': redBasicInfo.includes('bmi'),
            'background-light-yellow': yellowBasicInfo.includes('bmi'),
          }"
        >
          <app-sliding-scale
            [value]="profileInfo?.data?.donor?.bmi"
            [showValue]="true"
            [size]="'medium'"
            [config]="bmiScaleConfig"
            [customWidth]="'80%'"
          >
          </app-sliding-scale>
        </td>
        <td>
          <app-sliding-scale
            [value]="profileInfo?.data?.recipient?.bmi"
            [showValue]="true"
            [size]="'medium'"
            [config]="bmiScaleConfig"
            [customWidth]="'80%'"
          >
          </app-sliding-scale>
        </td>
      </tr>
      <tr>
        <td class="text-start ps-4 width-20pt">Ethnicity</td>
        <td>{{ profileInfo?.data?.donor?.ethnicity }}</td>
        <td>
          @if (
            isEditingRecipient && !profileInfo?.data?.recipient?.epicPatientId
          ) {
            <div class="d-flex flex-column">
              <small class="text-muted text-start mt-1"
                >Select Recipient's Ethnicity</small
              >
              <div ngbDropdown class="btn-group">
                <button
                  class="btn btn-sm dropdown-toggle"
                  style="border: 1px solid #dee2e6"
                  id="dropdownEthnicity"
                  ngbDropdownToggle
                >
                  {{ editableRecipient.ethnicity || "Ethnicity" }}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownEthnicity">
                  <button
                    ngbDropdownItem
                    *ngFor="let option of ethnicityOptions"
                    (click)="editableRecipient.ethnicity = option"
                  >
                    {{ option }}
                  </button>
                </div>
              </div>
            </div>
          } @else {
            {{ profileInfo?.data?.recipient?.ethnicity }}
          }
        </td>
      </tr>
      <tr>
        <td class="text-start ps-4 width-20pt">Gender</td>
        <td>{{ profileInfo?.data?.donor?.gender }}</td>
        <td>
          @if (
            isEditingRecipient && !profileInfo?.data?.recipient?.epicPatientId
          ) {
            <div class="d-flex flex-column">
              <small class="text-muted text-start mt-1"
                >Select Recipient's Gender</small
              >
              <div ngbDropdown class="btn-group">
                <button
                  class="btn btn-sm dropdown-toggle"
                  style="border: 1px solid #dee2e6"
                  id="dropdownGender"
                  ngbDropdownToggle
                >
                  {{ editableRecipient.gender || "Gender" }}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownGender">
                  <button
                    ngbDropdownItem
                    *ngFor="let option of genderOptions"
                    (click)="editableRecipient.gender = option"
                  >
                    {{ option }}
                  </button>
                </div>
              </div>
            </div>
          } @else {
            {{ profileInfo?.data?.recipient?.gender }}
          }
        </td>
      </tr>
      <tr>
        <td class="text-start ps-4 width-20pt">Relationship</td>
        <td class="centered-cell" colspan="2">
          {{ getRelationshipFromMetrics() }}
        </td>
      </tr>
      <tr>
        <td class="text-start ps-4 width-20pt">Reason for Kidney Failure</td>
        <td class="centered-cell" colspan="2">
          @if (isEditingRecipient) {
            <div class="d-flex flex-column">
              <small class="text-muted text-start mt-1"
                >Enter Reason for Kidney Failure</small
              >
              <input
                type="text"
                id="recipient-causeofesrd"
                class="form-control form-control-sm"
                [(ngModel)]="editableRecipient.causeOfEsrd"
              />
            </div>
          } @else {
            {{ profileInfo?.data?.recipient?.causeOfEsrd }}
          }
        </td>
      </tr>
    </tbody>
  </table>
</div>
